export default __webpack_public_path__ + "static/ombrea-851d673b598d6553d5d845ef1e48964e.png";